<template>
    <div class="mobile-menu-container">
        <div class="mobile-menu-wrapper">
            <span class="mobile-menu-close" @click="hideMobileMenu">
                <i class="icon-close"></i>
            </span>
            <form action="#" method="get" class="mobile-search" @submit.prevent="submitSearchForm">
                <label for="mobile-search" class="visually-hidden-focusable">Search</label>
                <input
                    type="search"
                    class="form-control"
                    autocomplete="off"
                    name="mobile-search"
                    id="mobile-search"
                    v-model="searchTerm"
                    placeholder="Search product ..."
                    required
                />
                <button class="btn btn-primary" type="submit">
                    <i class="icon-search"></i>
                </button>
            </form>
            <nav class="mobile-nav">
                <ul class="mobile-menu">                  
                    <li>
                        <nuxt-link
                            to="https://airabica.coffee/"
                        >New site</nuxt-link>
                    </li>
                    <li>
                        <!-- <nuxt-link to="/shop/nosidebar/boxed">Shop</nuxt-link> -->
                        <nuxt-link to="https://airabica.coffee/shop/">Shop</nuxt-link>
                        <ul>
                            <li>
                                <nuxt-link to="/shop/nosidebar/boxed" class="sf-with-ul">Category</nuxt-link>

                                <ul>
                                    <li>
                                        <nuxt-link to="https://airabica.coffee/shop/">Coffee</nuxt-link>
                                    </li>
                                    <li>
                                        <nuxt-link to="/shop/nosidebar/boxed?category=hotchocolate">Hot Chocolate</nuxt-link>
                                    </li>
                                    <li>
                                        <nuxt-link to="/shop/nosidebar/boxed?category=chai">Chai</nuxt-link>
                                    </li>
                                    <li>
                                        <nuxt-link to="/shop/nosidebar/boxed?category=rooibostea">Rooibos Tea</nuxt-link>
                                    </li>
                                    <li>
                                        <nuxt-link to="/shop/nosidebar/boxed?category=brewing">
                                            <span>
                                                Brewing Equipment
                                                <span class="tip tip-hot">Hot</span>
                                            </span>
                                        </nuxt-link>
                                    </li>
                                    <li>
                                        <nuxt-link to="/shop/nosidebar/boxed?category=grinder">
                                            <span>
                                                Grinders
                                            </span>
                                        </nuxt-link>
                                    </li>
                                    <li>
                                        <nuxt-link to="/shop/nosidebar/boxed?category=accessories">
                                            <span>
                                                Accessories
                                                <span class="tip tip-new">New</span>
                                            </span>
                                        </nuxt-link>
                                    </li>
                                    <!-- <li>
                                        <nuxt-link to="/shop/nosidebar/boxed?category=storage">
                                            <span>
                                                Storage
                                            </span>
                                        </nuxt-link>
                                    </li> -->
                                    <li>
                                        <nuxt-link to="/shop/nosidebar/boxed?category=drinkware">
                                            <span>
                                                Drinkware
                                                <span class="tip tip-new">Travel</span>
                                            </span>
                                        </nuxt-link>
                                    </li>
                                    <li>
                                        <nuxt-link to="/shop/nosidebar/boxed?category=roaster">
                                            <span>
                                                Roaster
                                            </span>
                                        </nuxt-link>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <nuxt-link to="/shop/nosidebar/boxed" class="sf-with-ul">Brand</nuxt-link>

                                <ul>
                                    <!-- <li>
                                        <nuxt-link to="/shop/nosidebar/boxed?brand=aeropress"
                                        >AeroPress</nuxt-link>
                                    </li> -->
                                    <li>
                                        <nuxt-link to="/shop/nosidebar/boxed?brand=airabica"
                                        >Airabica</nuxt-link>
                                    </li>
                                    <li>
                                        <nuxt-link to="/shop/nosidebar/boxed?brand=airscape"
                                        >Airscape</nuxt-link>
                                    </li>
                                    <li>
                                        <nuxt-link to="/shop/nosidebar/boxed?brand=bialetti"
                                        >Bialetti</nuxt-link>
                                    </li>
                                    <li>
                                        <nuxt-link to="/shop/nosidebar/boxed?brand=brutrek"
                                        >BruTrek</nuxt-link>
                                    </li>
                                    <li>
                                        <nuxt-link to="/shop/nosidebar/boxed?brand=espazzola"
                                        >Espazzola</nuxt-link>
                                    </li>
                                    <li>
                                        <nuxt-link to="/shop/nosidebar/boxed?brand=henlo"
                                        >Henlo</nuxt-link>
                                    </li>
                                    <li>
                                        <nuxt-link to="/shop/nosidebar/boxed?brand=idroprep"
                                        >Idroprep</nuxt-link>
                                    </li>
                                    <li>
                                        <nuxt-link to="/shop/nosidebar/boxed?brand=redespresso"
                                        >Red Espresso</nuxt-link>
                                    </li>
                                    <li>
                                        <nuxt-link to="/shop/nosidebar/boxed?brand=1zpresso"
                                        >1Zpresso</nuxt-link>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    <li>                
                        <NuxtLink to="https://gifts.airabica.co.za/" target="_blank">
                            Gifting
                        </NuxtLink>
                    </li>
                    <li>
                        <nuxt-link
                            to="/wholesale/order"
                        >Wholesale</nuxt-link>
                    </li>
                    <li>
                        <nuxt-link
                            to="/about-us"
                        >About us</nuxt-link>
                    </li>
                    <!-- <li>
                        <nuxt-link
                            to="/product/coffee/espresso-blend"
                            class="sf-with-ul"
                        >Product</nuxt-link>
                        <ul>
                            <li>
                                <nuxt-link
                                    to="/product/coffee/espresso-blend"
                                >Default</nuxt-link>
                            </li>
                            <li>
                                <nuxt-link
                                    to="/product/centered/espresso-blendg"
                                >Centered</nuxt-link>
                            </li>
                            <li>
                                <nuxt-link
                                    to="/product/extended/espresso-blend"
                                >
                                    <span>
                                        Extended Info
                                        <span class="tip tip-new">New</span>
                                    </span>
                                </nuxt-link>
                            </li>
                            <li>
                                <nuxt-link to="/product/gallery/espresso-blend">Gallery</nuxt-link>
                            </li>
                            <li>
                                <nuxt-link
                                    to="/product/sticky/espresso-blend"
                                >Sticky Info</nuxt-link>
                            </li>
                            <li>
                                <nuxt-link
                                    to="/product/sidebar/espresso-blend"
                                >Boxed With Sidebar</nuxt-link>
                            </li>
                            <li>
                                <nuxt-link
                                    to="/product/fullwidth/espresso-blend"
                                >Full Width</nuxt-link>
                            </li>
                            <li>
                                <nuxt-link
                                    to="/product/masonry/espresso-blends"
                                >Masonry Sticky Info</nuxt-link>
                            </li>
                        </ul>
                    </li> -->
                    <!-- <li>
                        <nuxt-link to="/blog/classic" class="sf-with-ul">Blog</nuxt-link>
                        <ul>
                            <li>
                                <nuxt-link to="/blog/classic">Classic</nuxt-link>
                            </li>
                            <li>
                                <nuxt-link to="/blog/listing">Listing</nuxt-link>
                            </li>
                            <li>
                                <nuxt-link to="/blog/grid/grid-2">Grid</nuxt-link>
                                <ul>
                                    <li>
                                        <nuxt-link to="/blog/grid/grid-2">Grid 2 columns</nuxt-link>
                                    </li>
                                    <li>
                                        <nuxt-link to="/blog/grid/grid-3">Grid 3 columns</nuxt-link>
                                    </li>
                                    <li>
                                        <nuxt-link to="/blog/grid/grid-4">Grid 4 columns</nuxt-link>
                                    </li>
                                    <li>
                                        <nuxt-link to="/blog/grid-sidebar">Grid sidebar</nuxt-link>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <nuxt-link to="/blog/masonry/masonry-2">Masonry</nuxt-link>
                                <ul>
                                    <li>
                                        <nuxt-link to="/blog/masonry/masonry-2">Masonry 2 columns</nuxt-link>
                                    </li>
                                    <li>
                                        <nuxt-link to="/blog/masonry/masonry-3">Masonry 3 columns</nuxt-link>
                                    </li>
                                    <li>
                                        <nuxt-link to="/blog/masonry/masonry-4">Masonry 4 columns</nuxt-link>
                                    </li>
                                    <li>
                                        <nuxt-link to="/blog/masonry-sidebar">Masonry sidebar</nuxt-link>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <nuxt-link to="/blog/mask/grid">Mask</nuxt-link>
                                <ul>
                                    <li>
                                        <nuxt-link to="/blog/mask/grid">Blog mask grid</nuxt-link>
                                    </li>
                                    <li>
                                        <nuxt-link to="/blog/mask/masonry">Blog mask masonry</nuxt-link>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <nuxt-link
                                    to="/blog/single/default/cras-ornare-tristique-elit."
                                >Single Post</nuxt-link>
                                <ul>
                                    <li>
                                        <nuxt-link
                                            to="/blog/single/default/cras-ornare-tristique-elit."
                                        >Default with sidebar</nuxt-link>
                                    </li>
                                    <li>
                                        <nuxt-link
                                            to="/blog/single/fullwidth/fusce-pellentesque-suscipit."
                                        >Fullwidth no sidebar</nuxt-link>
                                    </li>
                                    <li>
                                        <nuxt-link
                                            to="/blog/single/sidebar/utaliquam-sollicitzdvudin-leo."
                                        >Fullwidth with sidebar</nuxt-link>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li> -->
                    <!--li>
                        <nuxt-link to="/elements" class="sf-with-ul">Elements</nuxt-link>

                        <ul>
                            <li>
                                <nuxt-link to="/elements/products">Products</nuxt-link>
                            </li>
                            <li>
                                <nuxt-link to="/elements/typography">Typography</nuxt-link>
                            </li>
                            <li>
                                <nuxt-link to="/elements/titles">Titles</nuxt-link>
                            </li>
                            <li>
                                <nuxt-link to="/elements/banners">Banners</nuxt-link>
                            </li>
                            <li>
                                <nuxt-link to="/elements/categories">Product Category</nuxt-link>
                            </li>
                            <li>
                                <nuxt-link to="/elements/video-banners">Video Banners</nuxt-link>
                            </li>
                            <li>
                                <nuxt-link to="/elements/buttons">Buttons</nuxt-link>
                            </li>
                            <li>
                                <nuxt-link to="/elements/accordions">Accordions</nuxt-link>
                            </li>
                            <li>
                                <nuxt-link to="/elements/tabs">Tabs</nuxt-link>
                            </li>
                            <li>
                                <nuxt-link to="/elements/testimonials">Testimonials</nuxt-link>
                            </li>
                            <li>
                                <nuxt-link to="/elements/blog-posts">Blog Posts</nuxt-link>
                            </li>
                            <li>
                                <nuxt-link to="/elements/portfolio">Portfolio</nuxt-link>
                            </li>
                            <li>
                                <nuxt-link to="/elements/cta">Call to Action</nuxt-link>
                            </li>
                            <li>
                                <nuxt-link to="/elements/icon-boxes">Icon Boxes</nuxt-link>
                            </li>
                        </ul>
                    </li> -->
                    <li>
                        <nuxt-link
                            to="/contact-us"
                        >Contact Us</nuxt-link>
                    </li>
                </ul>
            </nav>
            <!-- <div class="social-icons">
                <a class="social-icon" target="_blank" title="Facebook" href="#">
                    <i class="icon-facebook-f"></i>
                </a>
                <a class="social-icon" target="_blank" title="Twitter" href="#">
                    <i class="icon-twitter"></i>
                </a>
                <a class="social-icon" target="_blank" title="Instagram" href="#">
                    <i class="icon-instagram"></i>
                </a>
                <a class="social-icon" target="_blank" title="Youtube" href="#">
                    <i class="icon-youtube"></i>
                </a>
            </div> -->
        </div>
    </div>
</template>
<script>
import Tabs from '~/components/elements/Tabs';
import { mobileMenu } from '~/utilities/common.js';

export default {
    data: function() {
        return {
            searchTerm: ''
        };
    },
    mounted: function() {
        mobileMenu();
    },
    methods: {
        hideMobileMenu: function() {
            document.querySelector('body').classList.remove('mmenu-active');
        },
        submitSearchForm: function() {
            this.hideMobileMenu();
            this.$router.push({
                path: '/shop/sidebar/3cols',
                query: {
                    searchTerm: this.searchTerm
                }
            });
            this.searchTerm = '';
        }

    }
};
</script>